import React from 'react';
import { Box } from '@mui/system';
import { ICONS } from './constants';

const Icon = React.forwardRef(({
  name,
  component = 'span',
  size = 'inherit',
  color,
  sx = {},
  ...props
}, ref) => {
  if (!ICONS[name]) {
    return null;
  }
  return (
    <Box
      ref={ref}
      component={component}
      sx={{
        fontFamily: "'OmnicartMP'",
        speak: 'never',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontVariant: 'normal',
        textTransform: 'none',
        lineHeight: 1,
        letterSpacing: 0,
        WebkitFontFeatureSettings: '"liga"',
        MozFontFeatureSettings: '"liga=1"',
        MsFontFeatureSettings: '"liga" 1',
        fontFeatureSettings: '"liga"',
        WebkitFontVariantLigatures: 'discretionary-ligatures',
        fontVariantLigatures: 'discretionary-ligatures',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontSize: size,
        color,
        '&:before': {
          content: `"${ICONS[name]}"`,
        },
        ...sx,
      }}
      {...props}
    />
  );
});

export default Icon;
